import script from "./certificate-template.vue?vue&type=script&lang=ts&setup=true"
export * from "./certificate-template.vue?vue&type=script&lang=ts&setup=true"

import "./certificate-template.vue?vue&type=style&index=0&id=b057ac34&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b057ac34"]])

export default __exports__